export default "__VITE_ASSET__BsMRctpU__"